import type { GTMEventWrapper } from './gtm-types';

export function isConsentGranted(): boolean {
	if (typeof document === 'undefined') return false;

	const match = document.cookie.match(/__privaci_cookie_consents=([^;]+)/);
	if (!match) return false;

	try {
		const consentData = JSON.parse(decodeURIComponent(match[1]));
		const consents = consentData.consents || {};

		const is297Allowed = consents['297'] !== 0;
		const is258Allowed = consents['258'] !== 0;

		return is297Allowed && is258Allowed;
	} catch {
		return false;
	}
}

const PII_FIELDS = new Set(['email', 'fullName', 'phoneNumber', 'zip', 'ip']);

function stripPIIValue(data: any): any {
	if (Array.isArray(data)) {
		return data.map(stripPIIValue);
	}

	if (!data || typeof data !== 'object') {
		return data;
	}

	const stripped = {};

	for (const key of Object.keys(data)) {
		if (!PII_FIELDS.has(key)) {
			stripped[key] = stripPIIValue(data[key]);
		}
	}

	return stripped;
}

export function stripPII(data: GTMEventWrapper): GTMEventWrapper {
	return stripPIIValue(data);
}
